import React from 'react';
import ServiceListItem from '../ServiceListItem';
import TabListTableCellWidthEnum from '../../Enums/TabListTableCellWidthEnum';
import LookupTextLookupItemIdArray from '../../Elements/LookupTextLookupItemIdArray';

export default class OnlineReputationServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'ProgramApproach',
      tabLabel: 'Program Approach',
      icon: 'fa-solid fa-diagram-project',
      data: [
        { name: 'MonitoringType', label: 'Online Monitoring or Online Reputation Management?' },
        { name: (item) => Array.isArray(item.PlatformsToMonitor) ? item.PlatformsToMonitor.join(', ') : (item.PlatformsToMonitor || ''), label: 'Media/Internet Platforms' },
        { name: 'FrequencyOfMonitoring', label: 'Frequency of Monitoring' },
        { name: (item) => <LookupTextLookupItemIdArray lookupId={20} valueArray={item.LanguagesToMonitor} />, label: 'Languages to Monitor' },
        { name: 'Keywords', label: 'Keywords' },
        { name: 'GoalOfProgram', label: 'Goal of the Program' },
        { name: (item) => Array.isArray(item.ScopeOfMonitoring) ? item.ScopeOfMonitoring.join(', ') : (item.ScopeOfMonitoring || ''), label: 'Scope of Monitoring' },
        { name: 'Coverage', label: 'Coverage' },
        { name: 'ClientGuidelines', label: 'Client Guidelines', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Reporting',
      tabLabel: 'Reporting',
      icon: 'fa-solid fa-file-lines',
      data: [
        { name: (item) => Array.isArray(item.ReportingRequirements) ? item.ReportingRequirements.join(', ') : (item.ReportingRequirements || ''), label: 'Reporting Requirements' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
